import { render, staticRenderFns } from "./PayByCheck.vue?vue&type=template&id=6352e996&scoped=true&"
import script from "./PayByCheck.vue?vue&type=script&lang=js&"
export * from "./PayByCheck.vue?vue&type=script&lang=js&"
import style0 from "./PayByCheck.vue?vue&type=style&index=0&id=6352e996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352e996",
  null
  
)

export default component.exports